(function () {
  function insertErrorPage(title, message) {
    const container = document.createElement('div');
    container.className = 'feature-disabled-error-page lagoon-bg';
    container.innerHTML = `
      <div class="feature-error-container">
        <div class="logo-section">
          <img src="https://staticassets.zuant.com/images/svgs/logos/zuant/ZUANT_CLOUD.svg" />
        </div>
        <div class="feature-error-message-section">
          <h1>${title}</h1>
          <p>${message}</p>
        </div>
      </div>
    `;
    document.body.innerHTML = '';
    document.body.appendChild(container);
  }

  function checkCookies() {
    return navigator.cookieEnabled;
  }

  function checkLocalStorage() {
    try {
      const testKey = '__zuant_test__';
      localStorage.setItem(testKey, '1');
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  function runFeatureChecksAndBootstrap() {
    if (!checkCookies()) {
      insertErrorPage(
        'Cookies are disabled',
        'This website requires cookies to function correctly. Please enable cookies in your browser settings and try again.'
      );
      return;
    }

    if (!checkLocalStorage()) {
      insertErrorPage(
        'Local Storage is disabled',
        'This website relies on local storage to function properly. Please enable it and try again.'
      );
      return;
    }

    // Only bootstrap Angular if all checks pass
    angular.element(document).ready(function () {
      angular.bootstrap(document, ['app']);
    });
  }

  runFeatureChecksAndBootstrap();
})();
